import { Box, customStyled, variant } from '@mafc/trolly';

export const Card = customStyled(Box)<{
  disabled?: boolean;
  onClick?: () => {};
}>(
  ({ disabled, onClick, theme }) => ({
    background: theme.colors.white,
    borderRadius: theme.radii[3],
    marginBottom: theme.space[3],
    opacity: disabled ? '0.7' : 1,
    padding: '12px 16px',
    position: 'relative',
    cursor: onClick ? 'pointer' : 'default',
  }),
  () =>
    variant({
      variants: {
        stacked: {
          display: 'block',
        },
        scattered: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        },
      },
    })
);

export const CardText = customStyled(Box)(({ theme }) => ({
  color: theme.colors.black,
  fontSize: theme.fontSizes[2],
}));

export const CardTitle = customStyled(CardText)<{ isApplied?: boolean }>(
  ({ theme, isApplied }) => ({
    fontWeight: theme.fontWeights[8],
    color: isApplied ? theme.colors.blue : theme.colors.black,
  })
);
